import React from 'react'

import PreviewTextFieldSkeleton from '../PreviewTextFieldSkeleton'

import useStyles from './styles'

function SkeletonActionButton({ isInProgress, showLoadingAnimation }) {
  const classes = useStyles()

  return (
    <PreviewTextFieldSkeleton
      isInProgress={isInProgress}
      className={classes.skeletonButtonLine}
      showLoadingAnimation={showLoadingAnimation}
    />
  )
}

export default SkeletonActionButton
